export default __webpack_public_path__ + "static/media/covid_care.1336855a.jpg";